import React from 'react';
import { Shield, Eye, Database, Lock } from 'lucide-react';
import { useTheme } from '../context/ThemeContext'; // 👈 Theme Support Added

const PrivacyPolicy = () => {
  const { isDark } = useTheme(); // 👈 Access Theme State

  const sections = [
    {
      icon: Eye,
      title: 'Information We Collect',
      content: 'When you use Odessey, we collect information you provide directly to us, such as your name, email address, phone number, and travel preferences. We also automatically collect certain information about your device and how you interact with our platform, including IP addresses, browser types, and booking history.'
    },
    {
      icon: Database,
      title: 'How We Use Your Data',
      content: 'We use the information we collect to provide, maintain, and improve our services. This includes processing your bookings, sending you travel updates, personalizing your travel recommendations, and communicating with you about promotions, security alerts, and administrative messages.'
    },
    {
      icon: Lock,
      title: 'Data Security & Storage',
      content: 'Your security is our priority. We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. Payment transactions are encrypted using industry-standard SSL technology and processed by secure third-party gateways.'
    },
    {
      icon: Shield,
      title: 'Sharing with Third Parties',
      content: 'We do not sell your personal data. We may share your information with trusted third-party service providers (such as airlines, hotels, and transport operators) strictly for the purpose of fulfilling your travel bookings. These partners are obligated to protect your data and use it only for the services requested.'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: isDark ? '#111827' : '#f9fafb', paddingBottom: '80px', fontFamily: 'system-ui, -apple-system, sans-serif', transition: 'background-color 0.3s', boxSizing: 'border-box' }}>
      
      {/* Hero Section */}
      <div style={{ backgroundColor: isDark ? '#030712' : '#111827', padding: '100px 16px 50px 16px', textAlign: 'center', position: 'relative', overflow: 'hidden', transition: 'background-color 0.3s' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url(https://images.unsplash.com/photo-1614064641913-6b71a3061280?auto=format&fit=crop&w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.15 }} />
        <div style={{ position: 'relative', zIndex: 10, maxWidth: '800px', margin: '0 auto', boxSizing: 'border-box' }}>
          <h1 style={{ color: 'white', fontSize: 'clamp(32px, 5vw, 42px)', fontWeight: '900', marginBottom: '10px' }}>Privacy Policy</h1>
          <p style={{ color: '#9ca3af', fontSize: '15px', lineHeight: '1.6' }}>Last updated: June 2026. Your privacy is critically important to us at Odessey.</p>
        </div>
      </div>

      {/* Content Container */}
      <div style={{ maxWidth: '800px', margin: '-30px auto 0', padding: '0 16px', position: 'relative', zIndex: 20, boxSizing: 'border-box' }}>
        <div style={{ backgroundColor: isDark ? '#1f2937' : 'white', borderRadius: '20px', padding: '30px 20px', boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.5)' : '0 10px 30px rgba(0,0,0,0.05)', border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', transition: 'background-color 0.3s, border-color 0.3s', boxSizing: 'border-box' }}>
          
          <p style={{ fontSize: '15px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.7', marginBottom: '30px' }}>
            Odessey ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by Odessey when you visit our website or use our travel booking services.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
            {sections.map((section, idx) => (
              <div key={idx} style={{ display: 'flex', gap: '15px', flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap' }}>
                <div style={{ flexShrink: 0, width: '42px', height: '42px', backgroundColor: isDark ? '#064e3b' : '#f0fdf4', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#16a34a' }}>
                  <section.icon size={22} />
                </div>
                <div>
                  <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: isDark ? '#f9fafb' : '#111827', marginBottom: '6px' }}>{section.title}</h3>
                  <p style={{ fontSize: '14px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.6', margin: 0 }}>{section.content}</p>
                </div>
              </div>
            ))}
          </div>

          <hr style={{ border: 'none', borderTop: isDark ? '1px solid #374151' : '1px solid #e5e7eb', margin: '30px 0' }} />

          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: isDark ? '#f9fafb' : '#111827', marginBottom: '6px' }}>Contact Us</h3>
          <p style={{ fontSize: '14px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.6', margin: 0 }}>
            If you have any questions or concerns about this Privacy Policy, please contact us at <strong style={{ color: isDark ? '#38bdf8' : '#0284c7' }}>privacy@odessey.in</strong> or via our support portal.
          </p>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;